// Enumerations
import { KycStatesEnumeration } from 'containers/kyc/enumerations/kyc-states.enumeration';
// Types
import {
  KycErrorBuilderHandlersType,
  KycErrorMethodsHandlersType,
} from './types/kyc-error.handlers.type';

const resetKycFlowButtonClickHandler = async ({
  setError,
  setKycState,
}: KycErrorBuilderHandlersType): Promise<void> => {
  setError(false);
  setKycState(KycStatesEnumeration.LANDING);
};

const KycErrorHandlers = (props: KycErrorBuilderHandlersType): KycErrorMethodsHandlersType => ({
  handleResetKycFlowButtonClick: () => resetKycFlowButtonClickHandler(props),
});

export { KycErrorHandlers };
